export const X_POINT = 32;
export const Y_AXIS_WIDTH = 56;
export const CHART_PADDING = { left: 0, right: 24, top: 8, bottom: 0 };

export function emptyLabels(): Array<string> {
  const labels: Array<string> = [];
  for (let i = 0; i <= X_POINT; i++) labels.push("");
  return labels;
}

export function partografYAxis(ticks: any): any {
  return {
    display: true,
    afterFit(scale) {
      scale.width = Y_AXIS_WIDTH;
    },
    gridLines: { drawBorder: true },
    ticks
  };
}

export function partografXAxes(): Array<any> {
  return [
    {
      offset: true,
      categoryPercentage: 1.0,
      barPercentage: 0.9,
      ticks: { display: false, autoSkip: false, maxRotation: 0 },
      gridLines: { display: true, drawTicks: false }
    }
  ];
}

export function partografLayout(): any {
  return { padding: CHART_PADDING };
}
